import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { QUOTETHEMES, getQuoteThemeClassNames } from 'constants/quoteThemes';
import { onPageEditing } from 'utils';

import css from './QuoteBlock.module.scss';

const QuoteBlock = ({
  quote,
  author,
  theme = QUOTETHEMES.yellow
}) => (
  <div
    className={cn(css.block, getQuoteThemeClassNames(css, theme))}
  >
    <div className={css.container}>
      <blockquote className={css.quote} {...onPageEditing('Quote')}>
        {quote}
      </blockquote>
      <div className={css.author} {...onPageEditing('Author')}>
        {author}
      </div>
    </div>
  </div>
);

QuoteBlock.propTypes = {
  quote: PropTypes.string,
  author: PropTypes.string,
  theme: PropTypes.oneOf(Object.keys(QUOTETHEMES).map((s) => QUOTETHEMES[s]))
};

export default QuoteBlock;



// WEBPACK FOOTER //
// ./src/components/QuoteBlock/QuoteBlock.jsx